<script setup>
import { computed, defineModel } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToggle } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';

import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['change']);

const modelValue = defineModel({
  type: String,
  default: 'all',
});

const { t } = useI18n();
const [showDropdown, toggleDropdown] = useToggle();

const statusOptions = computed(() => [
  'all',
  'open',
  'pending',
  'resolved',
  'snoozed',
].map(status => ({
  label: t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${status}.TEXT`),
  value: status,
  action: 'select',
  isSelected: modelValue.value === status,
})));

const selectedLabel = computed(() => {
  const current =
    statusOptions.value.find(option => option.value === modelValue.value) ||
    statusOptions.value[0];

  return `${props.label}: ${current.label}`;
});

const handleAction = item => {
  modelValue.value = item.value;
  toggleDropdown(false);
  emit('change');
};
</script>

<template>
  <div
    v-on-click-outside="() => toggleDropdown(false)"
    class="relative flex items-center group min-w-0 max-w-full"
  >
    <Button
      sm
      :variant="showDropdown || modelValue !== 'all' ? 'faded' : 'ghost'"
      slate
      :label="selectedLabel"
      trailing-icon
      icon="i-lucide-chevron-down"
      class="!px-2 max-w-full !justify-between"
      @click="toggleDropdown()"
    />
    <DropdownMenu
      v-if="showDropdown"
      :menu-items="statusOptions"
      class="mt-1 ltr:left-0 rtl:right-0 top-full w-56"
      @action="handleAction"
    />
  </div>
</template>
